/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extra_Session_Error_Cap_ReachedInputs */

const fr_extra_session_error_cap_reached = /** @type {(inputs: Extra_Session_Error_Cap_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu as déjà acheté le maximum de séances supplémentaires pour cette période.`)
};

/**

* @param {Extra_Session_Error_Cap_ReachedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const extra_session_error_cap_reached = /** @type {((inputs?: Extra_Session_Error_Cap_ReachedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extra_Session_Error_Cap_ReachedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_extra_session_error_cap_reached(inputs)
});